const HEADER_LEVEL = {
    'header-one': 1,
    'header-two': 2,
    'header-three': 3,
    'header-four': 4,
    'header-five': 5,
};

const getHeaderId = (key, text) => {
    const dashed_text = text.toLowerCase()
        .replace(/[^a-z-\d ]/g, '')
        .trim()
        .replace(/\s+/g, '-');
    return `header-${key}-${dashed_text}`;
};

const getTableOfContentsFromContentState = (contentState) => {
    const tableOfContents = [];

    contentState.blocks = contentState.blocks.forEach(({ key, type, text }) => {
        if (text.trim() && HEADER_LEVEL[type]) {
            const id = getHeaderId(key, text);
            const level = HEADER_LEVEL[type];
            tableOfContents.push({
                id, key, type, text, level,
            });
        }
    });

    return tableOfContents;
};

export {
    getHeaderId,
    getTableOfContentsFromContentState,
};
